import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { BookedActivity } from 'src/app/models/booked-activity.interface';

@Component({
    selector: 'app-customer-page',
    templateUrl: './customer-page.component.html',
    styleUrls: ['./customer-page.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule
    ]
})
export class CustomerPageComponent implements OnInit, AfterViewInit {

  userInfo: any;
  userFavoriteActivities: any[] = [];
  userBookings: any[] = [];
  dataSource: MatTableDataSource<any>;
  booked: BookedActivity[] = [];
  editInfo: boolean = false;
  userId: string = "";

  userInfoForm = new FormGroup({
    userFirstName: new FormControl({value: '', disabled: true}),
    userLastName: new FormControl({value: '', disabled: true}),
    userAddress: new FormControl({value: '', disabled: true}),
    userCity: new FormControl({value: '', disabled: true}),
    userPostalCode: new FormControl({value: '', disabled: true}),
    userStateProvince: new FormControl({value: '', disabled: true}),
    userCountry: new FormControl({value: '', disabled: true}),
    userPhone: new FormControl({value: '', disabled: true}),
    userEmail: new FormControl({value: '', disabled: true}),
  });

  constructor(private changeDectect: ChangeDetectorRef) { }

  userFavoritesColumns: string[] = ['name', 'mainActivityType', 'description'];
  userBookedColumns: string[] = ['date', 'slots', 'pricePerSlot', 'total', 'storeName', 'activityName']

  enableControls() {
    this.userInfoForm.controls.userFirstName.enable();
    this.userInfoForm.controls.userLastName.enable();
    this.userInfoForm.controls.userAddress.enable();
    this.userInfoForm.controls.userCity.enable();
    this.userInfoForm.controls.userPostalCode.enable();
    this.userInfoForm.controls.userStateProvince.enable();
    this.userInfoForm.controls.userCountry.enable();
    this.userInfoForm.controls.userPhone.enable();
    this.userInfoForm.controls.userEmail.enable();
  }

  disableControls() {
    this.userInfoForm.controls.userFirstName.disable();
    this.userInfoForm.controls.userLastName.disable();
    this.userInfoForm.controls.userAddress.disable();
    this.userInfoForm.controls.userCity.disable();
    this.userInfoForm.controls.userPostalCode.disable();
    this.userInfoForm.controls.userStateProvince.disable();
    this.userInfoForm.controls.userCountry.disable();
    this.userInfoForm.controls.userPhone.disable();
    this.userInfoForm.controls.userEmail.disable();
  }
  ngOnInit() {
    // TODO: Implement user authentication and data loading
    this.changeDectect.detectChanges();
  }

  ngAfterViewInit(): void {
    this.getData()
    this.changeDectect.detectChanges();
  }

  async getData() {
    // TODO: Implement user data loading
    let booked: BookedActivity[] = [];
    this.dataSource = new MatTableDataSource(booked);
  }

  onSubmit() {
    // TODO: Implement user update with Amplify Gen 2
    console.log('User info submitted:', this.userInfoForm.value);
    this.editInfo = false;
    this.disableControls();
  }

  editUserInfo() {
    this.enableControls();
    this.editInfo = true;
  }

}
